// extracted by mini-css-extract-plugin
export default {"pills-container":"_EpHKy","title":"KxHIWd","description":"lPvTeo"};